(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["phyticked"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector("#scroll-checklist");
  const items = section.querySelectorAll(".scroll-checklist-item");
  let animated = false;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !animated) {
          animated = true;
          items.forEach((item, i) => {
            setTimeout(() => {
              item.classList.add("tick-visible");
            }, i * 400);
          });
          obs.unobserve(section);
        }
      });
    },
    {
      threshold: 0.4
    }
  );

  observer.observe(section);
});

  } catch(e) { console.error(e); }
})();
})();
